import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

// Custom Component
import useLoading from "../../Loading/useLoading";
import TransmittalConfirmDialog from "../../Dialog/TransmittalConfirmDialog";
import WebViewer from "../../WebViewer/WebViewer";
import FullScreenDialog from "../../Dialog/FullScreenDialog";

// RFI Section
import TransmittalSelectedRFIGI from "./TransmittalSelectedRFIGI";
import RFIResponseHistory from "../RFI/rfiSection/RFIResponseHistory";
// Custom Style
import { rfiDetailFormStyle } from "../../../styles/jss/components/RFI/rfiDetailFormStyle";

import { getRFIDetails } from "../../../dataSource/rfi";

// Fetch Data
import { fileDownload } from "../../../dataSource/fileManager";

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));
const store = require("store");

const TransmittalSelectedRFIDetails = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    rfiSeq,
    setOpenDialog,
    setList,
    filterList,
    submissionValue,
    setSubmissionValue,
    buildAlert,
  } = props;
  const submissionTransmittalDetailRedux = useSelector(
    (state) => state.submissionTransmittalDetailRedux
  );
  const [getDetailsLoading, getDetailsShowLoading, getDetailsHiddenLoading] =
    useLoading();
  const [filePreviewProperty, SetFilePreviewProperty] = useState(null);
  const [noneditfilePreviewDialogOpen, setFileNonEditPreviewDialogOpen] =
    useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState({
    id: "",
    material: "",
    ref_no: "",
    atthDate: null,
    description: "",
    attachments: {},
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });

  const [transRFIValue, setTransRFIValue] = useState({});
  const [reponseHistoryValue, setResponseHistoryValue] = useState({
    transmittal: [],
  });

  const [transRFITemplate, setTransRFITemplate] = useState({
    id: "",
    material: "RFI",
    ref_no: "",
    atthDate: null,
    description: "",
    transmittal: [],
    messages: {
      parent_seq: 0,
      content: "",
      dms_property_seqs: [],
      files: [],
    },
  });
  const [userStageAction, setUserStageAction] = useState({
    IS_TRANSMITTABLE: "Y",
    IS_ATTACHMENT_READABLE: "Y",
  });

  const getRFIDetail = async () => {
    const response = await getRFIDetails(rfiSeq);
    setTransRFIValue(response.data);
    transRFITemplate.material = `${response.data.ref_no}.pdf`;
    transRFITemplate.ref_no = response.data.ref_no;
    transRFITemplate.atthDate = response.data.createdate;

    return response.data;
  };
  const fileNonEditPreviewDialogHandleOpen = () => {
    setFileNonEditPreviewDialogOpen(true);
  };
  const noneditfilePreviewDialogHandleClose = () => {
    setFileNonEditPreviewDialogOpen(false);
  };
  const noneditViewFileAction = (fileCat, fileSeq, filename) => {
    SetFilePreviewProperty({
      from: "API",
      autoLoading: true,
      file_cat: fileCat,
      file_ref: fileSeq,
      file_name: filename,
    });

    fileNonEditPreviewDialogHandleOpen();
  };

  const downloadFileAction = (fileCat, fileSeq) => {
    fileDownload(fileCat, fileSeq).then((res) => {
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: Document Submission");
      console.log("Message: File download successful.");
      console.log(
        "*****************************************************************************"
      );
    });
  };

  const confirmDialogHandleOpen = (data) => {
    setConfirmDialogData({
      material: data.material,
      ref_no: data.ref_no,
      atthDate: data.atthDate,
      description: data.description,
      rfi_seq: data.rfi_seq,
      transmittal: data.transmittal,
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });

    setConfirmDialogOpen(true);
  };

  const confirmDialogHandleClose = () => {
    setConfirmDialogOpen(false);
  };

  const addRFIConfirmation = () => {
    confirmDialogHandleOpen({
      material: transRFITemplate.material,
      ref_no: transRFITemplate.ref_no,
      atthDate: transRFITemplate.atthDate,
      description: transRFITemplate.description,
      transmittal: reponseHistoryValue.transmittal,
      rfi_seq: transRFIValue.rfi_seq,
      dialogTitle: "Please add details for the Transmittal ",
      dialogContent: "Are you sure to add this RFI to Transmittal?",
      cancelAction: confirmDialogHandleClose,
    });
  };

  useEffect(() => {
    getDetailsShowLoading();
    const fetchRFIAction = async () => {
      await getRFIDetail();
      getDetailsHiddenLoading();
    };

    fetchRFIAction();
  }, []);

  let noneditfileAttachmentPreviewDialogBtn = [];
  return (
    <Fragment>
      {getDetailsLoading}
      <TransmittalConfirmDialog
        open={confirmDialogOpen}
        material={confirmDialogData.material}
        ref_no={confirmDialogData.ref_no}
        atthDate={confirmDialogData.atthDate}
        transmittal={confirmDialogData.transmittal}
        rfi_seq={confirmDialogData.rfi_seq}
        description={confirmDialogData.description}
        setTransRFITemplate={setTransRFITemplate}
        transRFITemplate={transRFITemplate}
        dialogTitle={confirmDialogData.dialogTitle}
        dialogContent={confirmDialogData.dialogContent}
        setOpenDialog={setOpenDialog}
        setList={setList}
        filterList={filterList}
        submissionValue={submissionValue}
        setSubmissionValue={setSubmissionValue}
        buildAlert={buildAlert}
        fromRFI={false}
        // confirmAction={confirmDialogData.confirmAction}
        cancelAction={confirmDialogData.cancelAction}
        confirmDialogHandleClose={confirmDialogHandleClose}
      />
      <FullScreenDialog
        open={noneditfilePreviewDialogOpen}
        dialogTitle={"RFI Attachment File Preview"}
        formContent={
          <WebViewer
            property={filePreviewProperty}
            readOnly={true}
            zoom={false}
            move={false}
            ocr={false}
          />
        }
        button={noneditfileAttachmentPreviewDialogBtn}
        handleClose={noneditfilePreviewDialogHandleClose}

        // annotationChangeAlert={annotationChangeAlert}
      />
      <Grid item xs={12}>
        <Grid>
          <TransmittalSelectedRFIGI
            rfi_seq={rfiSeq}
            transRFIValue={transRFIValue}
            userStageAction={userStageAction}
            downloadFileAction={downloadFileAction}
            noneditViewFileAction={noneditViewFileAction}
          />
        </Grid>
        <Grid>
          <RFIResponseHistory
            rfi_seq={rfiSeq}
            submissionValue={transRFIValue}
            setSubmissionValue={setTransRFIValue}
            userStageAction={userStageAction}
            downloadFileAction={downloadFileAction}
            noneditViewFileAction={noneditViewFileAction}
            reponseHistoryValue={reponseHistoryValue}
            setResponseHistoryValue={setResponseHistoryValue}
            getDetailsShowLoading={getDetailsShowLoading}
            getDetailsHiddenLoading={getDetailsHiddenLoading}
            fromRFI={false}
          />
        </Grid>
        <Grid>
          <Grid>
            <Button
              variant="contained"
              color="primary"
              size="medium"
              style={{ marginLeft: 16 }}
              onClick={() => {
                setOpenDialog(false);
                setList(filterList);
              }}
            >
              Cancel and Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="medium"
              style={{ marginLeft: 16 }}
              onClick={() => addRFIConfirmation()}
            >
              Add This RFI to Transmittal
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default TransmittalSelectedRFIDetails;
